"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserService = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class UserService {
    /**
     * @param includeTs1Banner
     * @returns UserWithCapabilities The logged in users information
     * @throws ApiError
     */
    static showUser(includeTs1Banner = false) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/user',
            query: {
                'includeTs1Banner': includeTs1Banner,
            },
            errors: {
                403: `Unauthorized`,
                404: `Not Found`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns User The updated user
     * @throws ApiError
     */
    static updateUser(requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'PATCH',
            url: '/user',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Unauthorized`,
            },
        });
    }
    /**
     * @param teamId
     * @returns OfferResponse Ok
     * @throws ApiError
     */
    static getOffers(teamId) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/user/offers',
            query: {
                'teamId': teamId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }
    /**
     * @returns UserSubscriptionInfo Ok
     * @throws ApiError
     */
    static getUserSubscription() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/user/subscriptions',
        });
    }
    /**
     * @param requestBody
     * @returns CreateUserSubscriptionCheckoutResponse Ok
     * @throws ApiError
     */
    static createUserSubscriptionCheckout(requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/user/subscriptions/checkout',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns UpdateUserSubscriptionPaymentMethodResponse Ok
     * @throws ApiError
     */
    static updateSubscriptionPaymentMethod(requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/user/subscriptions/payment_method/update',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
}
exports.UserService = UserService;
